<template>
    <div>

        <van-nav-bar
                title="银行卡绑定"
                left-arrow
                :fixed="true"
                class="my-nav"
                @click-left="$router.back(-1)"
                :z-index="100"
        />
        <div style="margin-top: 30%;margin-left: 16px; margin-right: 16px;">
            <van-cell-group>
                <van-field
                        v-model="username"
                        required
                        clearable
                        label="开户名称"
                        placeholder="请输入开户名称"
                />

                    <van-field
                            v-model="bankCardNo"
                            required
                            clearable
                            label="银行卡号"
                            placeholder="请输入银行卡号"
                    />

                        <van-field
                                v-model="bankName"
                                required
                                clearable
                                label="开户行名称"
                                placeholder="请输入开户行名称"
                        />
            </van-cell-group>
            <van-button v-if="clicked" type="danger" block style="margin-top: 20px; z-index: 101" @click="addBank">确定提交信息</van-button>
            <van-button v-else disabled block style="margin-top: 20px; z-index: 101" >确定提交信息</van-button>
        </div>
    </div>
</template>

<script>
  import {Toast} from 'vant'
  import {addBank} from '../../api/ql-bank-card'

  export default {
      data() {
          return {
              username: '',
              bankCardNo:'',
              bankName: '',
              clicked: true
          }
      },

      methods: {
          addBank() {
              this.clicked = false
              setTimeout(function () {
                  this.clicked = true
              }, 5000);
              if (this.username == '') {
                  Toast('开户名称不得为空')
                  this.clicked = true
                  return;
              }
              if (this.bankCardNo == '') {
                  Toast('银行卡号不得为空')
                  this.clicked = true
                  return;
              }
              if (this.bankName == '') {
                  Toast('开户行名称不得为空')
                  this.clicked = true
                  return;
              }
              ;
              var params = {
                  username: this.username,
                  bankCardNo: this.bankCardNo,
                  bankName: this.bankName
              };
              addBank(params, d =>  {
                  Toast.success("银行卡绑定成功");
                  setTimeout(() => {
                      this.$router.push({name:'ql-bank-card'});
                  }, 2000);
              },e=>{
                  Toast.fail(e);
                  this.clicked = true
              })

          },
      }
  }
</script>

<style lang="less" scoped>

</style>
